export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.da8e9cf869867e4e78e1ebe2ffc04a58.css";